import React from "react";

export default function FormInput({
  type,
  name,
  placeholder,
  value,
  onChange,
  error,
  className,
  InputclassName,
}) {
  return (
    <>
      <div className={`${className} form-group`}>
        <input
          type={type}
          name={name}
          className={`${InputclassName} form-group`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          maxLength={type === "phone" ? 14 : null}
          minLength={type === "phone" ? 14 : null}
        />
        {error && (
          <div className="error-message" style={{ color: "red" }}>
            {error}
          </div>
        )}
      </div>
    </>
  );
}
